<template>
  <div>
    <base-card>
      <v-card-title>Generación de Formatos</v-card-title>
      <v-card-text class="line-text">
        <v-row justify="center" no-gutters>
          <v-col cols="12" sm="5">
            <v-form ref="form" v-model="formValid">
              <v-row justify="start">
                <v-col cols="12" sm="4">
                  <div>Año:</div>
                  <v-select
                    ref="year"
                    v-model="dataFilter.year"
                    :items="years"
                    item-text="text"
                    item-value="value"
                    :rules="[v => !!v || 'El año es obligatorio']"
                    prepend-inner-icon="mdi mdi-calendar-range"
                    required
                    dense
                    outlined
                  />
                </v-col>
                <v-col cols="12" sm="8">
                  <div>Formatos:</div>
                  <v-select
                    v-model="dataFilter.formats"
                    :items="filteredFormats"
                    item-text="description"
                    item-value="id"
                    multiple
                    outlined
                    dense
                    :rules="[v => (v && v.length > 0) || 'Seleccione al menos un formato']"
                  >
                    <template v-slot:prepend-item v-if="formatsList.length > 5">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-text-field
                              v-model="search"
                              placeholder="Buscar"
                              prepend-inner-icon="mdi-magnify"
                              hide-details
                              dense
                            />
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <div>Fecha inicial:</div>
                  <v-dialog v-model="modalStart" persistent width="300px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFilter.startDate"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                      />
                    </template>

                    <v-date-picker
                      v-model="dataFilter.startDate"
                      :max="dataFilter.endDate"
                      @input="modalStart = false"
                    />
                  </v-dialog>
                </v-col>
                <v-col cols="12" sm="6">
                  <div>Fecha final:</div>
                  <v-dialog v-model="modalEnd" persistent width="300px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dataFilter.endDate"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        :disabled="!dataFilter.startDate"
                      />
                    </template>

                    <v-date-picker
                      v-model="dataFilter.endDate"
                      :min="dataFilter.startDate"
                      @input="modalEnd = false"
                    />
                  </v-dialog>
                </v-col>
              </v-row>
            </v-form>
          </v-col>
        </v-row>

        <v-row v-if="showAlert || isLoading" justify="center" class="my-4">
          <v-progress-linear
            v-if="isLoading"
            class="my-4"
            color="danger"
            indeterminate
          ></v-progress-linear>
          <v-col cols="12" sm="6">
            <v-alert
              v-if="showAlert"
              :type="alertType"
              dense
              outlined
              border="left"
              colored-border
              class="my-4"
            >
              {{ alertMessage }}
            </v-alert>
          </v-col>
        </v-row>
        <v-row justify="end" no-gutters>
          <v-col cols="12" sm="6" class="text-sm-right">
            <v-btn
              :disabled="isLoading"
              :loading="isLoading"
              class="ma-2"
              style="background-color: rgb(204 33 40); color: white !important"
              @click="generateFormats()"
            >
              <v-icon left>mdi mdi-creation-outline</v-icon>
              Generar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="mt-5 line-text">
        <v-toolbar flat dense>
          <v-toolbar-title>
            Tabla de formatos generados
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                :loading="loadingTable"
                :disabled="loadingTable"
                color="rgb(204 33 40)"
                class="white--text border-button"
                @click="getGeneratedFormats()"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>

            <span>Refrescar tabla</span>
          </v-tooltip>
        </v-toolbar>

        <v-data-table
          :headers="headers"
          :items="dataTable"
          :search="searchTable"
          :loading="loadingTable"
          loading-text="Cargando Formatos..."
          class="elevation-1 mt-5"
        >
          <template v-slot:[`item.statusDescription`]="{ item }">
            <v-chip
              :color="getStatusColor(item.statusDescription)"
              medium
              class="white--text border-button px-4"
            >
              {{ item.statusDescription }}
            </v-chip>
          </template>
          <template v-slot:[`item.creationDate`]="{ item }">
            <div style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ item.creationDate }}
            </div>
          </template>
          <template v-slot:[`item.formatDescription`]="{ item }">
            <div style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ item.formatDescription }}
            </div>
          </template>
          <template v-slot:[`item.fileName`]="{ item }">
            <!-- <a :href="item.fileName" target="_blank">{{ item.fileName }}</a> -->
            <v-btn
              v-if="item.fileName != null"
              color="rgb(36 24 213)"
              class="white--text border-button"
              @click="downloadFile(item.fileName)"
            >
              <v-icon>mdi mdi-download-box</v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.dates`]="{ item }">
            <div style="max-width: 250px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
              {{ formatDate(item.contentStartDate) }} - {{ formatDate(item.contentEndDate) }}
            </div>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              color="rgb(204 33 40)"
              class="white--text border-button"
              @click="deleteFormat(item.id)"
            >
              <v-icon>mdi mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
    </base-card>
    <v-overlay :value="loading" absolute opacity="0.6">
      <v-progress-circular
        indeterminate
        size="64"
        color="rgb(204 33 40)"
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      dataTable: [],
      dataFilter: {
        year: null,
        formats: [],
        startDate: null,
        endDate: null,
      },
      loadingTable: false,
      years: [],

      formatsList: [],
      search: "",
      isLoading: false,
      showAlert: false,
      alertMessage: "",
      alertType: "success",
      formValid: false,
      modalStart: false,
      modalEnd: false,
      processedDocsData: [],
      headers: [
        { text: "Estado", value: "statusDescription", align: "center" },
        { text: "Fecha creación", value: "creationDate", align: "center" },
        { text: "Formato", value: "formatDescription", align: "center", width: 150 },
        { text: "Rango de fechas", value: "dates", align: "center" },
        { text: "Descargar", value: "fileName", align: "center" },
        { text: "Mensaje", value: "comment", align: "center" },
        { text: "Eliminar", value: "actions", align: "center" },
      ],
      loading: false,
      searchTable: null,
    };
  },
  watch: {
    'dataFilter.startDate'(newVal) {
      if (newVal) {

        // Si endDate es menor que startDate, lo limpiamos
        if (this.dataFilter.endDate && this.dataFilter.endDate < newVal) {
          this.dataFilter.endDate = null
        }
      } else {
        this.dataFilter.endDate = null
      }
    },
    'dataFilter.year'(newVal) {
      if (newVal) {

        const firstDay = new Date(newVal, 0, 1)
          .toISOString()
          .split('T')[0];

        const lastDay = new Date(newVal, 11, 31)
          .toISOString()
          .split('T')[0];
          
        this.dataFilter.startDate = firstDay;
        this.dataFilter.endDate = lastDay;
      }
    }
  },
  mounted() {
    this.idCompany = JSON.parse(atob(localStorage.getItem("uid"))).idcompania;
    this.fetchToken();
    this.getLastTenYearsDesc();
  },
  computed: {
    filteredFormats() {
      if (!this.search) return this.formatsList;

      const query = this.search.toLowerCase();
      return this.formatsList.filter((f) =>
        f.text.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    async fetchToken() {
      this.loading = true;

      try {
        const tokenInfo = JSON.parse(localStorage.getItem("tokenCompany"));
        console.log(tokenInfo);
        
        if (tokenInfo && tokenInfo.idCompany === this.idCompany && tokenInfo.expiresAt > Date.now()) {
          this.token = tokenInfo.token;
        } else {
          const token = await this.$store.dispatch(
            "fetchToken/getTokenByCompany",
            this.idCompany
          );

          if (!token) {
            this.setAlert("error", "Error al obtener token");
            return;
          }

          this.token = token;

          localStorage.setItem("tokenCompany", JSON.stringify({idCompany: this.idCompany, token, expiresAt: Date.now() + 30 * 60 * 1000,}));
        }

        await this.getFormats();
        await this.getGeneratedFormats();
      } catch (e) {
        this.setAlert("error", "Error al obtener token");
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async getFormats() {
      this.loading = true;
      try {
        const response = await this.$store.dispatch("generationFormatsExogena/getFormats", {
          token: this.token,
        });

        this.formatsList = response;
      } catch (error) {
        console.error("Error al estraer formatos", error);
        this.setAlert("error", "Ocurrió un error durante estraccion de formatos.");
      } finally {
        this.loading = false;
      }
    },
    getLastTenYearsDesc() {
      const currentYear = new Date().getFullYear();
      const endYear = currentYear;

      this.years = Array.from({ length: 10 }, (_, i) => {
        const year = endYear - i;
        return {
          text: year.toString(),
          value: year,
        };
      });
    },
    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = "";
      this.alertType = "success";
      this.showAlert = false;
    },

    clearFields() {
      this.dataFilter = {
        company: null,
        consecutive: "",
      };
      this.search = "";
      this.token = null;
      this.infoInvoice = [];
      this.showModal = false;
    },
    async getGeneratedFormats() {
      this.loadingTable = true;
      try {
        const response = await this.$store.dispatch("generationFormatsExogena/getGeneratedFormats", {
          token: this.token,
          idCompany: this.idCompany,
        });

        this.dataTable = response;
        
      } catch (error) {
        console.error("Error al extraer los formatos de la dian:", error);
        this.setAlert("error", "Ocurrió un error durante la extracion de los formatos previamente generados.");
      } finally {
        this.loadingTable = false;
      }
    },
    async generateFormats() {
      if (!this.$refs.form.validate()) return;

      this.loading = true;
      try {
        

        await this.$store.dispatch("generationFormatsExogena/generateFormats", {
          idCompany: this.idCompany,
          token: this.token,
          dataFilter: this.dataFilter,
        });

        this.setAlert("success", "Se envió a generar el formato correctamente.");
        this.$refs.form.reset();
        this.getGeneratedFormats()
      } catch (e) {
        this.setAlert("error", "Error al generar formatos");
        console.error(e);
      } finally {
        this.loading = false;
      }

    },
    onAccept() {
      this.modal = false;
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('es-CO');
    },
    getStatusColor(status) {
      if (!status) return "grey";

      switch (status.toLowerCase()) {
        case "procesado":
          return "rgb(26 157 31)";
        case "error":
          return "rgb(204 33 40)";
        case "pendiente":
          return "orange";
        default:
          return "grey";
      }
    },
    downloadFile(url) {
      const link = document.createElement('a');
      link.href = url;
      // link.download = ''; // opcional (el navegador toma el nombre del archivo)
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }, 
    async deleteFormat(id) {
      this.loading = true;
      try {

        await this.$store.dispatch("generationFormatsExogena/deleteFormat", {
          idCompany: this.idCompany,
          token: this.token,
          id: id,
        });

        await this.getGeneratedFormats();
      } catch (error) {
        console.error("Error al estraer formatos", error);
        this.setAlert("error", "Ocurrió un error durante eliminacion de formatos.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.icon-warning {
  color: rgb(204 33 40);
  font-size: 100px;
}
.tx-center {
  text-align: center;
}
.line-text {
  border: 1px solid #dfdfdf !important;
  border-radius: 15px;
}
.pad-text {
  padding: 10px;
}
</style>
